import React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import {
  CircularProgress,
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";
import { getAverageExecutionTime } from "../../api/api";
import { ValuationTypeFilter } from "../../types/api.types";

type DateFilterType = "createdAt" | "evaluatedAt" | "evaluationStarted";

interface AverageExecutionTimeProps {
  dateFilterType: DateFilterType;
  valuationType?: ValuationTypeFilter;
}

export const AverageExecutionTime: React.FC<AverageExecutionTimeProps> = ({
  dateFilterType,
  valuationType,
}) => {
  const { t } = useTranslation();

  const { data: averageExecutionTimeData, isLoading: isLoadingAverageTime } =
    useQuery(["averageExecutionTime", dateFilterType, valuationType], () =>
      getAverageExecutionTime(dateFilterType, valuationType)
    );

  if (!isLoadingAverageTime && !averageExecutionTimeData) {
    return null;
  }

  return (
    <Box style={{ marginBottom: "20px" }}>
      <Typography variant="h6" style={{ marginBottom: "15px" }}>
        {t("valuationsStatistics.averageExecutionTime.title")}
      </Typography>
      {isLoadingAverageTime ? (
        <CircularProgress size={24} />
      ) : (
        <Box style={{ display: "flex", gap: "20px" }}>
          <Card style={{ minWidth: "180px" }}>
            <CardContent>
              <Typography variant="body2" color="textSecondary">
                {t("valuationsStatistics.averageExecutionTime.last7Days")}
              </Typography>
              <Typography variant="h5">
                {averageExecutionTimeData?.last7Days !== null
                  ? `${averageExecutionTimeData?.last7Days?.toFixed(2)} ${t(
                      "valuationsStatistics.days"
                    )}`
                  : t("valuationsStatistics.averageExecutionTime.noData")}
              </Typography>
            </CardContent>
          </Card>
          <Card style={{ minWidth: "180px" }}>
            <CardContent>
              <Typography variant="body2" color="textSecondary">
                {t("valuationsStatistics.averageExecutionTime.last30Days")}
              </Typography>
              <Typography variant="h5">
                {averageExecutionTimeData?.last30Days !== null
                  ? `${averageExecutionTimeData?.last30Days?.toFixed(2)} ${t(
                      "valuationsStatistics.days"
                    )}`
                  : t("valuationsStatistics.averageExecutionTime.noData")}
              </Typography>
            </CardContent>
          </Card>
        </Box>
      )}
    </Box>
  );
};
